export default __webpack_public_path__ + "static/media/Layer 2 (1).32870838.svg";